import React from "react";
import styled from "styled-components";
import typography, { rhythm } from "../utils/typography"
import presets from "../utils/presets";



const H2 = styled.h2`
  color: ${props => props.light ? presets.accent : presets.dark };
  text-transform: capitalize;
  position:relative;
  margin: ${rhythm(2)} 0;
  ${'' /* display:inline-block; */}
`

export default H2



// WEBPACK FOOTER //
// ./src/com/H2.js